export class ProjectWorkspaceSummary {
    overdueCount = 0;
    todayTasksCount = 0;
    todayAppointmentsCount = 0;
}
